import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../services/store';
import { IModal } from '../types/modal';
import { PURGE } from 'redux-persist';

const modalAdapter = createEntityAdapter<IModal>();
const initialState = modalAdapter.getInitialState();

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    modalToggled: (state, action) => {
      const { id, isOpen } = action.payload;
      if (id !== 'pdfConverting') {
        modalAdapter.removeMany(
          state,
          state.ids.filter(
            (mId) => mId !== id && mId !== 'upload-mydrive-progress'
          )
        );
      }
      modalAdapter.upsertOne(state, {
        ...action.payload,
        isOpen: isOpen ?? !state.entities[id]?.isOpen,
      });
    },
    modalDataUpdated: modalAdapter.upsertOne,
    modalRemoveAll: modalAdapter.removeAll,
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState);
  },
});

export const { modalToggled, modalDataUpdated, modalRemoveAll } =
  modalSlice.actions;

export default modalSlice.reducer;

export const { selectAll: selectModalList, selectById: selectModalById } =
  modalAdapter.getSelectors((state: RootState) => state.modal);
